export { default as Img200 } from './processed/200/Eagle-The.jpg';
export { default as Img400 } from './processed/400/Eagle-The.jpg';
export { default as Imgthumb } from './processed/thumb/Eagle-The.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Eagle-The.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Eagle-The.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      188,
      79,
      51
    ],
    "_population": 18,
    "_hsl": [
      0.034063260340632597,
      0.5732217573221758,
      0.46862745098039216
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      223,
      202
    ],
    "_population": 268,
    "_hsl": [
      0.10294117647058822,
      0.47222222222222254,
      0.8588235294117648
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      137,
      50,
      36
    ],
    "_population": 74,
    "_hsl": [
      0.023102310231023104,
      0.5838150289017341,
      0.3392156862745098
    ]
  },
  "Muted": {
    "_rgb": [
      145,
      125,
      96
    ],
    "_population": 430,
    "_hsl": [
      0.09863945578231292,
      0.2033195020746888,
      0.4725490196078431
    ]
  },
  "LightMuted": {
    "_rgb": [
      196,
      198,
      182
    ],
    "_population": 2311,
    "_hsl": [
      0.18749999999999992,
      0.12307692307692306,
      0.7450980392156863
    ]
  },
  "DarkMuted": {
    "_rgb": [
      95,
      67,
      50
    ],
    "_population": 2071,
    "_hsl": [
      0.06296296296296297,
      0.3103448275862069,
      0.28431372549019607
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Eagle-The.js